import React from 'react';
export const DEALER_LOGOS = ['lyon.png', 'niello.png', 'carl_black.png', 'bmw-of-westlake.png', 'mark-miller-subaru.png', 'eh_auto.png', 'goodwin.png', 'continental_ag.png', 'ewing.png', 'classic.png', 'bmw-store.png', 'emich.png', 'sunset-ford.png', 'classic.png', 'mohawk.png', 'dreyer_reinbold.png', 'lyon.png', 'niello.png', 'carl_black.png', 'bmw-of-westlake.png', 'mark-miller-subaru.png', 'eh_auto.png', 'goodwin.png', 'continental_ag.png', 'ewing.png', 'classic.png', 'bmw-store.png', 'emich.png', 'sunset-ford.png', 'classic.png', 'mohawk.png', 'dreyer_reinbold.png'];
export const LogoCarousel = () => <div className="logo-carousel-container">
    <div className="logo-scroll">
      {/* <!-- Repeat the set of logos to simulate an infinite scroll --> */}
      {/* <!-- Make sure to duplicate the logos to fill the visible area adequately --> */}
      {DEALER_LOGOS.map((item, index) => <div className="logo-item" key={index}>
          <img src={`assets/images/dealership-logos/${item}`} alt={item} />
        </div>)}
      {/* Repeat logos again to facilitate continuous animation */}
      {DEALER_LOGOS.map((item, index) => <div className="logo-item" key={index}>
          <img src={`assets/images/dealership-logos/${item}`} alt={item} />
        </div>)}
    </div>
  </div>;
export const DynamicLogoCarousel = ({
  logos
}: {
  logos: string[];
}) => {
  // No need to manually repeat logos multiple times
  // We'll use CSS animation to create the infinite effect

  return <div className="logo-carousel-container">
      <div className="logo-scroll">
        <div className="logo-track">
          {logos.map((item, index) => <div className="logo-item" key={`original-${index}`}>
              <img src={`${item}`} alt={item.split('/').pop() || 'dealer logo'} style={{
            maxWidth: "100px"
          }} />
            </div>)}
          {/* Duplicate set for seamless looping */}
          {logos.map((item, index) => <div className="logo-item" key={`duplicate-${index}`}>
              <img src={`${item}`} alt={item.split('/').pop() || 'dealer logo'} style={{
            maxWidth: "100px"
          }} />
            </div>)}
        </div>
      </div>
      <style jsx>{`
        .logo-carousel-container {
          width: 100%;
          overflow: hidden;
          position: relative;
        }
        .logo-scroll {
          overflow: hidden;
          width: 100%;
          padding: 20px 0;
        }
        .logo-track {
          display: flex;
          animation: scroll 30s linear infinite;
          width: fit-content;
        }
        .logo-item {
          flex-shrink: 0;
          padding: 0 20px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            /* Move exactly the width of one set of logos */
            transform: translateX(-50%);
          }
        }
      `}</style>
    </div>;
};